import { Logo } from "@/components/Logo";
import { SITE } from "@/config/site";
import { scrollToSection } from "@/lib/scroll";

const FOOTER_LINKS = [
  { id: "beranda", label: "Beranda" },
  { id: "tentang", label: "Tentang Kami" },
  { id: "layanan", label: "Layanan" },
  { id: "proyek", label: "Proyek" },
  { id: "kontak", label: "Kontak" },
];

export const Footer = () => (
  <footer className="bg-navy-dark" aria-label="Footer">
    <div className="mx-auto grid max-w-7xl gap-12 px-4 py-16 sm:px-6 md:grid-cols-3 lg:px-12">
      <div>
        <a
          href="#beranda"
          data-testid="footer-logo"
          onClick={(e) => {
            e.preventDefault();
            scrollToSection("#beranda");
          }}
          aria-label="PT. Prime Karya Mandiri — kembali ke beranda"
        >
          <Logo size="lg" />
        </a>
        <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-400">
          Solusi konstruksi, renovasi, dan pembangunan yang direncanakan dengan
          matang serta dikerjakan oleh tim profesional.
        </p>
      </div>

      <nav aria-label="Navigasi footer">
        <h3 className="font-heading text-sm font-bold uppercase tracking-[0.18em] text-orange-400">
          Navigasi
        </h3>
        <ul className="mt-5 space-y-3">
          {FOOTER_LINKS.map((link) => (
            <li key={link.id}>
              <a
                href={`#${link.id}`}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection(`#${link.id}`);
                }}
                className="text-sm text-slate-300 transition-colors duration-200 hover:text-orange-400"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>
      </nav>

      <div>
        <h3 className="font-heading text-sm font-bold uppercase tracking-[0.18em] text-orange-400">
          Kontak
        </h3>
        <ul className="mt-5 space-y-3 text-sm text-slate-300">
          <li>
            Alamat:{" "}
            <span className={SITE.address ? "text-slate-300" : "italic text-slate-500"}>
              {SITE.address || "Segera tersedia"}
            </span>
          </li>
          <li>WhatsApp: {SITE.whatsappDisplay}</li>
          <li>
            Email:{" "}
            <span className={SITE.email ? "text-slate-300" : "italic text-slate-500"}>
              {SITE.email || "Segera tersedia"}
            </span>
          </li>
          <li>
            Jam Operasional:{" "}
            <span className={SITE.workingHours ? "text-slate-300" : "italic text-slate-500"}>
              {SITE.workingHours || "Segera tersedia"}
            </span>
          </li>
        </ul>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-4 py-6 sm:px-6 md:flex-row lg:px-12">
        <p data-testid="footer-copyright" className="text-xs text-slate-500">
          © {new Date().getFullYear()} {SITE.name}. Seluruh hak cipta dilindungi.
        </p>
        <p className="text-xs text-slate-600">{SITE.tagline}</p>
      </div>
    </div>
  </footer>
);
